module.exports = {"TXTCLI_Address":{"id":"TXTCLI_Address","defaultMessage":"Διεύθυνση","flags":["TRACK"],"track":"Address"}}